// extracted by mini-css-extract-plugin
export default {"container":"bro_2hJXO","item":"bro_ite_35zhN","image":"bro_ima_2DlMP","date":"bro_dat_1ZF0g","button":"bro_but_1R-zJ","icon":"bro_ico_3M7ET","label":"bro_lab_3NdQ-"};